import Axios from "axios"

export const getAutomaticDiscounts = () => {
  return Axios.post("/api/postAutomaticDiscounts", {})
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
    })
}

export const postBulkOrder = (data, callback) => {
  return Axios({
    data,
    headers: { Accept: "*/*", "Content-Type": "application/json" },
    method: "POST",
    url: "/api/postBulkOrder",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      callback()
    })
}

export const getFenixShippingEstimate = (
  buyerZipCode: string,
  skus: Array<{ quantity: number; sku: string }>
) => {
  return Axios.post("/api/postFenixShippingEstimate", {
    buyerZipCode,
    skus,
  })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
    })
}

const pending = new Map<string, Promise<any>>()
export const getInventoryByLocation = (skus: string[]) => {
  // Stable key
  const key = JSON.stringify([...new Set(skus)].sort())
  if (pending.has(key)) return pending.get(key)!

  const response = Axios.post("/api/postInventoryByLocation", { skus })
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
    })
    .finally(() => pending.delete(key))

  pending.set(key, response)
  return response
}

export const getOrder = (data) => {
  return Axios.post("/api/postOrder", data)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
    })
}

export const postOutOfStock = (data, callback) => {
  Axios({
    data,
    headers: { Accept: "*/*", "Content-Type": "application/json" },
    method: "POST",
    url: "/api/postOutOfStock",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      callback()
    })
}

export const postSubscribeNewsletter = (data, callback) => {
  return Axios({
    data,
    headers: { "Content-Type": "application/json" },
    method: "POST",
    url: "/api/postSubscribeNewsletter",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      callback()
    })
}

export const postWarrantyClaim = (data, callback) => {
  return Axios({
    data,
    headers: { Accept: "*/*", "Content-Type": "application/json" },
    method: "POST",
    url: "/api/postWarrantyClaim",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      callback()
    })
}

export const getGeo = () => {
  return Axios({
    method: "GET",
    url: "/api/getGeo",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
}

export const getRewardsBalance = (data) => {
  return Axios({
    data,
    method: "POST",
    url: "/api/getRewardsBalance",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
}

export const setCartId = (cartId) => {
  return Axios({
    data: { cartId },
    headers: { "Content-Type": "application/json" },
    method: "POST",
    url: "/api/setCartId",
  })
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
}
